import React from 'react';

const Downloads = () => {
    return (
        <div className="page-wrapper">
            <div className="header-section">
                <div className="logo-container">
                    <svg className="logo-icon" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
                    </svg>
                </div>
                <h1>Download App</h1>
                <p>Get the Attendance System app for your device</p>
            </div>

            <div className="role-grid" style={{ marginTop: '20px' }}>
                <a href="/downloads/app.apk" download className="role-card" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <div className="role-card-icon">🤖</div>
                    <div className="role-card-title">Android (APK)</div>
                    <p style={{ fontSize: '12px', opacity: 0.7 }}>Requires Android 8.0+</p>
                </a>

                <a href="/downloads/app-release.ipa" download className="role-card" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <div className="role-card-icon">🍏</div>
                    <div className="role-card-title">iOS (IPA)</div>
                    <p style={{ fontSize: '12px', opacity: 0.7 }}>Requires iOS 12.0+</p>
                </a>

                <a href="/downloads/app.exe" download className="role-card" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <div className="role-card-icon">💻</div>
                    <div className="role-card-title">Desktop (Windows)</div>
                    <p style={{ fontSize: '12px', opacity: 0.7 }}>Windows 10/11</p>
                </a>
            </div>

            <div className="footer-links" style={{ marginTop: '30px' }}>
                <p>
                    <a href="/login">Back to Login</a>
                </p>
            </div>
        </div>
    );
};

export default Downloads;
